import React, { useState, useContext, useEffect } from 'react';
import GameContext from '../context/game/GameContext';

function Box(prop) {
    const [filledData, setfilledData] = useState([
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
    ]);
    
    const context = useContext(GameContext);
    const { originalData, GameR, addDashboardEntry, setIsRunning } = context;
    const GameInitial = GameR;
    const [value, setvalue] = useState(prop.num);
    let tid = "t" + prop.id;
    let cellId = prop.id;
    let i = parseInt(cellId / 9);
    let j = cellId % 9;
    
    useEffect(() => {
        setvalue(prop.num);
    }, [prop.num]);

    const check = () => {
        if (JSON.stringify(filledData) === JSON.stringify(originalData)) {
            setIsRunning(false);
            if (localStorage.getItem('token')) {
                addDashboardEntry(
                    localStorage.getItem('userid'),
                    localStorage.getItem('username'),
                    localStorage.getItem('gameid'),
                    document.querySelector('input[name="level"]:checked').value,
                    document.getElementById("timer").innerHTML
                );
            }
            if (document.getElementById('CompleteModal').classList.contains('hidden')) {
                document.getElementById('CompleteModal').classList.remove('hidden');
                document.getElementById('CompleteModal').classList.add('flex');
            }
        }
    };

    const handleChange = (e) => {
        let value = parseInt(e.target.value);
        if (isNaN(value) || value < 1 || value > 9) {
            e.target.value = '';
            return;
        }
        GameInitial[i][j] = value;
        setfilledData([...GameInitial]);
        console.log(JSON.stringify(filledData));
        check();
        if (document.querySelector('input[name="level"]:checked').value === "Easy") {
            if (value !== originalData[i][j]) {
                document.getElementById(cellId)?.classList?.add('text-red-900');
                if (document.getElementById(cellId)?.classList?.contains('text-green-900')) {
                    document.getElementById(cellId)?.classList?.remove('text-green-900');
                }
            } else {
                document.getElementById(cellId)?.classList?.add('text-green-900');
                if (document.getElementById(cellId)?.classList?.contains('text-red-900')) {
                    document.getElementById(cellId)?.classList?.remove('text-red-900');
                }
            }
        } else {
            document.getElementById(cellId)?.classList?.add('text-black');
        }
    };

    if ((i === 2 && j === 2) || (i === 2 && j === 5) || (i === 5 && j === 2) || (i === 5 && j === 5)) {
        if (value !== 0)
            return (
                <td id={tid} className='text-center border-2 border-b-4 border-r-4 border-black align-middle'>
                    <div id={prop.id} className='flex border-black justify-center items-center text-lg lg:text-2xl md:w-8 md:h-8 font-bold w-6 h-6 lg:w-12 lg:h-12 outline-none bg-transparent'>{value}</div>
                </td>
            );
        else
            return (
                <td id={tid} className='text-center border-2 border-b-4 border-r-4 border-black align-middle'>
                    <input id={prop.id} className='text-center text-lg lg:text-2xl md:w-8 md:h-8 font-bold w-6 h-6 lg:w-12 lg:h-12 outline-none' onChange={handleChange} type="number" min="1" max="9" />
                </td>
            );
    }

    if (i === 2 || i === 5) {
        if (value !== 0)
            return (
                <td id={tid} className='text-center border-2 border-b-4 border-black align-middle'>
                    <div id={prop.id} className='flex border-black justify-center items-center text-lg lg:text-2xl md:w-8 md:h-8 font-bold w-6 h-6 lg:w-12 lg:h-12 outline-none bg-transparent'>{value}</div>
                </td>
            );
        else
            return (
                <td id={tid} className='text-center border-2 border-b-4 border-black align-middle'>
                    <input id={prop.id} className='text-center text-lg lg:text-2xl md:w-8 md:h-8 font-bold w-6 h-6 lg:w-12 lg:h-12 outline-none' onChange={handleChange} type="number" min="1" max="9" />
                </td>
            );
    }

    if (j === 2 || j === 5) {
        if (value !== 0)
            return (
                <td id={tid} className='text-center border-2 border-r-4 border-black align-middle'>
                    <div id={prop.id} className='flex border-black justify-center items-center text-lg lg:text-2xl md:w-8 md:h-8 font-bold w-6 h-6 lg:w-12 lg:h-12 outline-none bg-transparent'>{value}</div>
                </td>
            );
        else
            return (
                <td id={tid} className='text-center border-2 border-r-4 border-black align-middle'>
                    <input id={prop.id} className='text-center text-lg lg:text-2xl md:w-8 md:h-8 font-bold w-6 h-6 lg:w-12 lg:h-12 outline-none' onChange={handleChange} type="number" min="1" max="9" />
                </td>
            );
    }

    if (value !== 0)
        return (
            <td id={tid} className='text-center border-2 border-black align-middle'>
                <div id={prop.id} className='flex border-black justify-center items-center text-lg lg:text-2xl md:w-8 md:h-8 font-bold w-6 h-6 lg:w-12 lg:h-12 outline-none bg-transparent'>{value}</div>
            </td>
        );
    else
        return (
            <td id={tid} className='text-center border-2 border-black align-middle'>
                <input id={prop.id} className='text-center text-lg lg:text-2xl md:w-8 md:h-8 font-bold w-6 h-6 lg:w-12 lg:h-12 outline-none' onChange={handleChange} type="number" min="1" max="9" />
            </td>
        );
}

export default Box;
